
import * as DOMPurify from 'isomorphic-dompurify'
import containerSizes from '../../EoContainer/EoContainer.scss?module'

export default {
  name: "PreprText",
  functional: true,
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => { },
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => { },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  render(createElement, context) {
    // Prepr data model https://developers.prepr.io/reference#text
    const model = {
      format: null,
      body: null,
    }
    const normalizedData = { ...model, ...context.props.data }

    /**
     * Prepr puts lists (ul, ol) inside a paragraph. HTML doesnt allow that.
     * Lets split it up into seperate renderable chunks
     */
    function renderableChunks() {
      let chunks = []

      if (normalizedData.format !== null) {
        // Text is a heading
        chunks.push({
          format: normalizedData.format,
          body: normalizedData.body,
        })
      } else {
        // Text is a paragraph (with tags in it)
        let body = normalizedData.body
        let restOfBody = body
        let chunk = null
        let regexOpeningTag = RegExp('<p[^>]*>|<ol[^>]*>|<ul[^>]*>', 'g')
        let foundOpeningTag
        let foundClosingTag
        let previousIndex = 0

        while ((foundOpeningTag = regexOpeningTag.exec(body)) !== null) {
          // Make a chunk of everything up to this opening tag
          if (previousIndex !== foundOpeningTag.index) {
            chunk = body.substring(previousIndex, foundOpeningTag.index)
            chunks.push({
              format: 'p',
              body: chunk,
            })
          }

          // Continue after this chunk
          previousIndex = foundOpeningTag.index
          restOfBody = body.slice(previousIndex)

          // Find the end tag
          foundClosingTag = RegExp('<\/p>|<\/ol>|<\/ul>', 'g').exec(restOfBody)

          // Make a chunk of everything from opening to closing tag
          chunk = restOfBody.substring(0, foundClosingTag.index + foundClosingTag[0].length)
          const chunkTag = chunk.match(/<(\w+)\s*.*?>/)
          let format = 'p'
          if (chunkTag && chunkTag[1]) {
            format = chunkTag[1]
          }
          chunks.push({
            format,
            body: chunk.substring(chunk.indexOf('>') + 1, chunk.lastIndexOf('<')),
          })

          // Continue after this chunk
          previousIndex = previousIndex + chunk.length
          restOfBody = body.slice(previousIndex)
        }

        // Make a chunk of everything left
        if (restOfBody && restOfBody.trim()) {
          chunks.push({
            format: 'p',
            body: restOfBody,
          })
        }
      }
      return chunks
    }

    /**
     * Render an element for each chunk
     */
    return renderableChunks().map((chunk) => {
      return createElement(
        chunk.format,
        {
          class: context.props.overwrites?.class,
          style: {
            'max-width': context.props.overwrites?.size ? containerSizes[`container-width-${context.props.overwrites.size}`] : null,
            ...context.props.overwrites?.style,
          },
          domProps: { innerHTML: DOMPurify.sanitize(chunk.body, { ADD_ATTR: ['target'] }) }, // equal to v-html inside a <template>
        },
      )
    })
  },
}
